<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a" id="contents"><a id="page_ix"></a>Contents</h2>
<p class="toc-fm"><a class="nounder" href="#/xhtml/acknowledgments">Acknowledgments</a></p>
<p class="toc-fm"><a class="nounder" href="#/xhtml/introduction">Introduction</a></p>
<p class="toc-h1"><a class="nounder" href="#/xhtml/part01"><span class="small">PART I</span>. THE VIEW FROM LONDON</a></p>
<p class="toc-h2"><a class="nounder" href="#/xhtml/ch01"><span class="small">CHAPTER ONE</span>. “The Tyrant.” George III</a>.</p>
<p class="toc-h2"><a class="nounder" href="#/xhtml/ch02"><span class="small">CHAPTER TWO</span>. The Prime Minister. Lord North.</a></p>
<p class="toc-h1"><span class="nounder" href="#/xhtml/part02" title="Link target outside of Sample"><span class="small">PART II</span>. VICTORY AND DEFEAT IN THE NORTH (1776–1778)</span></p>
<p class="toc-h2"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample"><span class="small">CHAPTER THREE</span>. The Peace Commissioners? The Howe Brothers.</span></p>
<p class="toc-h2"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample"><span class="small">CHAPTER FOUR</span>. “The Old Gamester.” John Burgoyne.</span></p>
<p class="toc-h2"><a id="page_x"></a><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample"><span class="small">CHAPTER FIVE</span>. “The Achilles of the American War.” Lord George Germain.</span></p>
<p class="toc-h1"><span class="nounder" href="#/xhtml/part03" title="Link target outside of Sample"><span class="small">PART III</span>. VICTORY AND DEFEAT IN THE SOUTH (1778–1781)</span></p>
<p class="toc-h2"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample"><span class="small">CHAPTER SIX.</span> “The Scapegoat.” Sir Henry Clinton.</span></p>
<p class="toc-h2"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample"><span class="small">CHAPTER SEVEN</span>. “Bagging the Fox.” Charles, Earl Cornwallis.</span></p>
<p class="toc-h1"><span class="nounder" href="#/xhtml/part04" title="Link target outside of Sample"><span class="small">PART IV</span>. VICTORY AGAINST FRANCE AND SPAIN (1782)</span></p>
<p class="toc-h2"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample"><span class="small">CHAPTER EIGHT</span>. “Saint George.” Sir George Rodney.</span></p>
<p class="toc-h2"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample"><span class="small">CHAPTER NINE</span>. “Jemmy Twitcher.” The Earl of Sandwich.</span></p>
<p class="toc-backt"><span class="nounder" href="#/xhtml/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
<p class="toc-backt"><span class="nounder" href="#/xhtml/ch05#ch05fig1" title="Link target outside of Sample"><em>Color plates follow page</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?33cc0540